<template>
  <div class="home">
    <p class="ciudad" v-if="frame == 0">{{ciudad}}</p>
    <Abu :class="['abu', 'frame_' + frame]" :frame="frame"/>
    <div class="intro" v-if="frame == 0">
      <img src="img/abu_logo_text.svg" alt="abuelapp"/>
      <!-- <button @click="darConsejo()">mano botón</button> -->
      <div class="adios">
        <input v-model="mano" class="mano" type="range" min="0" max="100" />
        <p>Desliza para despedirte de la abuelapp</p>
      </div>
    </div>
    <div v-else-if="frame == 1" class="preconsejo">
      <h3>
        ¿Pero cómo vas a salir así,<br>
        alma de cántaro?
      </h3>
    </div>
    <Consejo v-else-if="frame == 2" :tiempo="tiempo" />
  </div>
</template>

<script>
// @ is an alias to /src
import Consejo from '@/components/Consejo.vue'
import Abu from '@/components/Abu.vue'

export default {
  name: 'Home',
  components: {Consejo, Abu},
  props: {
    tiempo: {},
    ciudad: String
  },
  data() {
    return {
      mano: 50,
      izda: false,
      dcha: false,
      frame: 0,
    }
  },
  watch: {
    mano() {
			if (this.mano < 10) {
				this.izda = true;
			} else if (this.mano > 90) {
				this.dcha = true;
			}
			if (this.izda && this.dcha) {
				this.darConsejo()
			}
    },
    tiempo() {
      if (this.frame == 1) this.frame++;
    },
    frame() {
      if (this.frame == 1) setTimeout(() => this.tiempo ? this.frame++ : '', 2000);
    }
  }, 
  methods: {
    darConsejo() {
      // this.$router.push({name: 'Consejo'});
      setTimeout(() => this.frame = 1, 800);
    }
  }
}
</script>
<style scoped lang="scss">
.home {
  .ciudad {
    padding-top: 1em;
  }
  .abu {
    margin-top: 30%;
    margin-bottom: 5%;
    transition: all .5s ease;
    height: auto;
    &.frame_2 {
      width: 20vw;
      margin-top: 10%; 
      margin-bottom: 5%; 
    }
  }
  .adios {
    position: absolute;
    bottom: 10vh;
    left: 15%;
    width: 70%;
    .mano {
      -webkit-appearance: none!important;
      width: 100%;
      // height: 2px;
      outline: none;
      padding: 0;
      margin: 0;
      transition: all .2s ease-out;
      // Range Handle
      &::-webkit-slider-thumb {
        -webkit-appearance: none;
        width: 7rem;
        height: 7rem;
        background-image: url('../../public/img/mano.svg');
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center top;
        cursor: pointer;
        margin-top: -1em;
        border: none;
        transition: all .2s ease;
        &:hover {margin-top: -2em;}
      }
      &::-webkit-slider-runnable-track {
        width: 100%;
        height: 5rem;
        cursor: pointer;
        background-image: url('../../public/img/mano_slide.svg');
        background-size: 100% 100%;
        background-position: center;
      }
    }
    p {
      text-align: center;
      width: 100%;
      margin-top: 2em;
    }
  }
}
</style>
